export type FormulaArgument = {
  text: string;
  index: number;
  attributeId: string;
  linkId?: string;
};

// В серверных формулах встречаются числовые ID и UUID.
const uid = "(?:[\\da-f]{8}(?:-[\\da-f]{4}){3}-[\\da-f]{12}|\\d+)";

export const parseFormulaArguments = (formula: string): FormulaArgument[] => {
  // Ссылку читаем целиком, чтобы её целевой атрибут не стал отдельным аргументом.
  const argument = new RegExp(
    `\\b(?:o(${uid})\\s*\\(\\s*a(${uid})\\s*\\)|a(${uid})\\b)`,
    "g",
  );
  return Array.from(formula.matchAll(argument)).flatMap((match) => {
    const [text, linkId, linkedAttributeId, directAttributeId] = match;
    const attributeId = linkedAttributeId ?? directAttributeId;
    if (attributeId === undefined || match.index === undefined) return [];
    return [{ text, index: match.index, attributeId, linkId }];
  });
};
